import { useTheme } from '@mui/material';

export const IntroIcon3 = ({ className }: { className: string }) => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
    } = theme.colors.other.icon;

    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="22"
            viewBox="0 0 24 22"
            fill="none"
        >
            <path
                d="M4.125 0.585815C1.84688 0.585815 0 2.43269 0 4.71082V17.4608C0 19.7389 1.84688 21.5858 4.125 21.5858H19.875C22.1531 21.5858 24 19.7389 24 17.4608V9.21082C24 6.93269 22.1531 5.08582 19.875 5.08582H5.625C5.00156 5.08582 4.5 5.58738 4.5 6.21082C4.5 6.83425 5.00156 7.33582 5.625 7.33582H19.875C20.9109 7.33582 21.75 8.17488 21.75 9.21082V17.4608C21.75 18.4968 20.9109 19.3358 19.875 19.3358H4.125C3.08906 19.3358 2.25 18.4968 2.25 17.4608V4.71082C2.25 3.67488 3.08906 2.83582 4.125 2.83582H21.375C21.9984 2.83582 22.5 2.33425 22.5 1.71082C22.5 1.08738 21.9984 0.585815 21.375 0.585815H4.125ZM18 14.8358C18.3978 14.8358 18.7794 14.6778 19.0607 14.3965C19.342 14.1152 19.5 13.7336 19.5 13.3358C19.5 12.938 19.342 12.5565 19.0607 12.2752C18.7794 11.9939 18.3978 11.8358 18 11.8358C17.6022 11.8358 17.2206 11.9939 16.9393 12.2752C16.658 12.5565 16.5 12.938 16.5 13.3358C16.5 13.7336 16.658 14.1152 16.9393 14.3965C17.2206 14.6778 17.6022 14.8358 18 14.8358Z"
                fill={primaryStroke}
            />
        </svg>
    );
};
